// removed by extract-text-webpack-plugin
module.exports = {"container":"_2meEBhwF3btMGR0fVrnTgg","market":"_1SIXmM_n4zKCltq0YR3T4e","price":"_3DRYK0uFUvrsVmPHTGIUXp","variation":"bdjxXsS4RNb38vFG2Y4nx","volume":"_2G4ExW0CQp6ftCmO-FUqgO"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/List/Header/Desktop/styles.css
// module id = 1595
// module chunks = 85